import { MsalProvider } from "@azure/msal-react";
import { CssBaseline } from "@mui/material";
import { AppThemeProvider } from "App.theme";
import { isAuthConfigured } from "authConfig";
import { CustomApolloProvider } from "CustomApolloProvider";
import { msalInstance } from "msalInstance";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./index.scss";
import { ReduxStore } from "./redux-store";

const AppContent = (
  <CustomApolloProvider>
    <AppThemeProvider>
      <CssBaseline>
        <App />
      </CssBaseline>
    </AppThemeProvider>
  </CustomApolloProvider>
);

ReactDOM.render(
  <Provider store={ReduxStore}>
    <React.StrictMode>
      {isAuthConfigured ? (
        <MsalProvider instance={msalInstance}>{AppContent}</MsalProvider>
      ) : (
        AppContent
      )}
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);
